export default __webpack_public_path__ + "static/media/irrigation-4.e439ee48.jpg";